export default __webpack_public_path__ + "static/media/Playzone-fit-Wack-a-tag-2.ac4bc2ed.jpg";